import { CreditUsage } from 'api/clients/CreditUsageClient'
import { useWebsocketConnection } from 'providers/WebsocketProvider'
import { useEffect } from 'react'

export interface Props {
  workspaceId: number
  onUpdate?: (creditUsage: CreditUsage) => void
}

interface CreditUsageMessage {
  event: 'credit_usage_update'
  credit_usage: CreditUsage
}

export const useCreditUsageSubscription = ({ workspaceId, onUpdate }: Props) => {
  const websocketConnection = useWebsocketConnection()

  useEffect(() => {
    if (!websocketConnection) return

    const subscription = websocketConnection.subscriptions.create(
      { channel: 'CreditUsageChannel', workspace_id: workspaceId },
      {
        received: (message: CreditUsageMessage) => {
          if (message.event === 'credit_usage_update') {
            const { credit_usage } = message
            onUpdate?.(credit_usage)
          }
        },
      },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [workspaceId, websocketConnection, onUpdate])
}
